export function prefixPath(path: string) {
  const base = (process.env.NEXT_PUBLIC_BASE_PATH || '').trim();
  if (!base || base === '/') return path.startsWith('/') ? path : `/${path}`;
  const rhs = path.startsWith('/') ? path : `/${path}`;
  return `${base}${rhs}`;
}
